import { Box, Grid, Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import ProductPriceTypography from 'artkive/components/PageSections/ProductPriceTypography'
import { TrackButton } from 'artkive/components/Tracker'
import { BREAKPOINTS } from 'artkive/utils/constants'

export const GridContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  zIndex: 0,
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    maxWidth: '382px',
    margin: '0 auto',
  },
}))

export const GridItem = styled(Grid)(({ theme }) => ({
  padding: '0 !important',
  marginBottom: '32px',
  [theme.breakpoints.up(BREAKPOINTS.md)]: {
    padding: '16px !important',
    marginBottom: '64px',
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    marginBottom: '96px',
  },
  [theme.breakpoints.up(1360)]: {
    padding: '32px !important',
  },
}))

export const Card = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    flexDirection: 'row',
  },
}))

export const DigitalCard = styled(Box)(({ theme }) => ({
  padding: 0,
  display: 'flex',
  gap: 0,
  maxHeight: 'auto',
  [theme.breakpoints.up(BREAKPOINTS.md)]: {
    gap: '24px',
    maxWidth: '643px',
    margin: '0 auto',
    '& > div': {
      alignItems: 'flex-start',
      textAlign: 'left',
      gap: '8px',
      width: 'auto',
      '& .image': {
        maxHeight: '268px !important',
        width: 165,
        height: 'auto',
        objectFit: 'contain',
        marginTop: '24px',
      },

      // TODO ref to LearnMoreButtonLink when migrate to v5
      '& .learn-more-button-link': {
        marginTop: '16px',
      },

      // TODO ref to PriceBox when migrate to v5
      '& .price-box': {
        marginTop: 0,
      },
    },
  },
  [theme.breakpoints.up(1280)]: {
    '& > div': {
      '& picture': {
        height: 'auto !important',
      },
      '& .image': {
        marginTop: 0,
      },
    },
  },
}))

export const Picture = styled('picture')({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  '& > img': {
    objectFit: 'contain',
    height: '100%',
    width: '100%',
  },
})

export const ImageWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 120,
  height: 90,
  '& img, & picture': {
    borderRadius: '4px',
    height: '100%',
  },
  [theme.breakpoints.up(BREAKPOINTS.md)]: {
    width: '100%',
    height: '100%',
    '& img, & picture': {
      objectFit: 'cover',
      borderRadius: '8px',
      height: 210,
    },
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    '& img, & picture': {
      height: 300,
    },
  },
}))

export const StorageBadgeImage = styled('img')({
  position: 'absolute',
  top: 0,
  right: 0,
  width: 120,
  height: '120px !important',
})

export const Title = styled(Typography)({
  fontSize: '1.25rem',
})

export const ProductPrice = styled(ProductPriceTypography)(({ theme }) => ({
  fontSize: '1.125rem',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.5rem',
  },
}))

export const PriceText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 600,
  [theme.breakpoints.up('md')]: {
    fontSize: '1rem',
  },
}))

export const LearnMoreButtonLink = styled(TrackButton)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    marginTop: 32,
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
    alignSelf: 'flex-start',
  },
}))

export const Description = styled(Box)(({ theme }) => ({
  flex: 1,
  marginLeft: 16,
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
    textAlign: 'center',
    marginLeft: 0,
    marginTop: 12,
  },
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    marginTop: 32,
  },
}))

export const PriceBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  marginTop: '4px',
  [theme.breakpoints.up('md')]: {
    marginTop: '12px',
  },
}))

export const AdditionalBox = styled('div')(({ theme }) => ({
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    marginTop: 32,
  },
}))

export const InnerAdditionalBox = styled('div')(({ theme }) => ({
  margin: '0 40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  padding: '40px 100px',
  maxWidth: 1057,
  borderRadius: 4,
  border: `1px solid ${theme.colors.sky[300]}`,
  textAlign: 'center',
  backgroundColor: 'white',
  [theme.breakpoints.down(BREAKPOINTS.md)]: {
    textAlign: 'center',
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: 0,
    padding: 0,
    margin: 0,
  },
}))

export const SectionTitle = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(6),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(8),
  },
}))
